import { Component, OnInit, inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import { BarManagementService, Organization, OrganizationQuery, OrganizationQueryResponse } from 'src/app/api/api-bar-management.service.generated';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { AsyncPipe } from '@angular/common';
import { DataTableComponent, TableColumn } from "wecheer-common";

@Component({
  selector: 'app-advertiser-organizations-search',
  templateUrl: './advertiser-organizations-search.component.html',
  styleUrls: ['./advertiser-organizations-search.component.scss'],
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatTableModule,
    MatButtonModule,
    AsyncPipe,
    DataTableComponent
  ]
})
export class AdvertiserOrganizationsSearchComponent implements OnInit {
  private bmApi = inject(BarManagementService);
  dialogRef = inject<MatDialogRef<AdvertiserOrganizationsSearchComponent>>(MatDialogRef);
  data = inject<{
    organizationId: string;
  }>(MAT_DIALOG_DATA);


  querySubject = new BehaviorSubject<string>('');
  isLoading = true;
  organizations$: Observable<Organization[]>;
  columns: TableColumn[] = [
    {
      name: 'name',
      header: 'Name',
    },
    {
      name: 'description',
      header: 'Description',
    }
  ]

  constructor() {

    this.organizations$ = this.querySubject.pipe(
      debounceTime(1000),
      switchMap(query => {
        this.isLoading = true;
        return this.bmApi.queryOrganizations(new OrganizationQuery({
          names: [query],
          skip: 0,
          maxItems: 100
        }))
      }),
      map((resp: OrganizationQueryResponse) => {
        this.isLoading = false;
        return resp.items || [];
      })
    );
  }

  static async open(dialog: MatDialog, organizationId: string): Promise<Organization | undefined> {
    const result = await lastValueFrom(dialog.open(AdvertiserOrganizationsSearchComponent, { width: '600px', height: '600px', data: { organizationId } }).afterClosed());
    return result as (Organization | undefined);
  }
  ngOnInit() {
  }

  onChange(newValue: string) {
    this.querySubject.next(newValue);
  }

  selectOrganization(account: Organization) {
    this.dialogRef.close(account);
  }


}
